const productData = [
  {
    id: 1,
    name: "Frill-trim organic cotton blouse",
    category: "Blouses",
    price: "45.00",
    reviews: "124",
    rating: "4.5",
    image: "/img/ovh-product-01.png",
    homeImage: "/img/ovh-home-product-01.png",
    images: ["/img/ovh-product-01.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["White", "Black"],
    material: "100% Organic Cotton",
    description: [
      "Elevate your everyday wardrobe with this stunning frilled blouse, designed to offer a perfect blend of comfort and style.",
      "Featuring delicate ruffle details along the neckline and shoulders, this piece adds a touch of feminine charm to any outfit.",
      "Crafted from premium organic cotton, it provides exceptional breathability and a soft touch against the skin.",
      "The relaxed fit ensures freedom of movement while maintaining a flattering silhouette suitable for all body types.",
      "Perfect for both office wear and casual weekend outings, this versatile blouse pairs beautifully with tailored trousers or your favorite jeans."
    ],
    Features: [
      "Elegant frill detailing on the collar and shoulders",
      "Made from eco-friendly 100% organic cotton",
      "Relaxed, comfortable fit for all-day wear",
      "Button-loop fastening at the back neck",
      "Machine washable for easy care and maintenance"
    ],
  },
  {
    id: 2,
    name: "Front-ruched half-sleeve top",
    category: "Tops",
    price: "55.00",
    reviews: "89",
    rating: "4.7",
    image: "/img/ovh-product-02.png",
    homeImage: "/img/ovh-home-product-02.png",
    images: ["/img/ovh-product-02.png"],
    size: ["XS", "S", "M", "L"],
    colors: ["Black", "Navy"],
    material: "95% Viscose, 5% Elastane",
    description: [
      "A modern wardrobe essential, this ruched top brings a sophisticated twist to the classic t-shirt silhouette.",
      "The strategic ruching down the front creates a flattering draped effect that complements the natural curves of the body.",
      "Cut from a soft, stretchy viscose blend, it offers a form-fitting yet comfortable feel that moves with you.",
      "Featuring half-length sleeves and a classic crew neckline, it strikes the right balance between casual and chic.",
      "An ideal layering piece under blazers or worn on its own with high-waisted skirts or trousers for a polished look."
    ],
    Features: [
      "Flattering front ruched detailing",
      "Soft and stretchy viscose blend fabric",
      "Classic crew neckline with half-sleeves",
      "Form-fitting silhouette that enhances the figure",
      "Versatile design suitable for day-to-night styling"
    ],
  },
  {
    id: 3,
    name: "High-rise straight-leg jeans",
    category: "Jeans",
    price: "70.00",
    reviews: "215",
    rating: "4.6",
    image: "/img/ovh-product-03.png",
    homeImage: "/img/ovh-home-product-03.png",
    images: ["/img/ovh-product-03.png"],
    size: ["26", "27", "28", "29", "30", "31", "32"],
    colors: ["Beige", "Light Blue", "Black"],
    material: "99% Cotton, 1% Elastane",
    description: [
      "Redefine your denim collection with these classic straight-leg jeans, offering a timeless aesthetic and modern comfort.",
      "Designed with a flattering high-rise waist that cinches gently and provides excellent coverage and support.",
      "The straight cut from hip to hem elongates the legs, creating a sleek and streamlined silhouette.",
      "Constructed from durable denim with a hint of stretch, ensuring they hold their shape while allowing for comfortable movement.",
      "Finished with classic five-pocket styling and versatile neutral washes that pair effortlessly with any top in your closet."
    ],
    Features: [
      "Flattering high-rise waistline",
      "Classic straight-leg cut for a timeless look",
      "Durable denim construction with a touch of stretch",
      "Traditional five-pocket styling with zip fly",
      "Available in versatile, easy-to-style washes"
    ],
  },
  {
    id: 4,
    name: "Boxy dropped-shoulder cotton tee",
    category: "T-shirts",
    price: "49.00",
    reviews: "340",
    rating: "4.8",
    image: "/img/ovh-product-04.png",
    homeImage: "/img/ovh-home-product-04.png",
    images: ["/img/ovh-product-04.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Navy", "White", "Grey"],
    material: "100% Cotton",
    description: [
      "The ultimate staple for laid-back styling, this loose fit t-shirt is designed for maximum comfort and effortless cool.",
      "Featuring a boxy, oversized silhouette with dropped shoulders that create a relaxed and modern drape.",
      "Crafted from premium, mid-weight cotton that feels incredibly soft against the skin and provides excellent durability.",
      "The classic crew neckline and wide sleeves add to its easy-going appeal, making it a go-to piece for everyday wear.",
      "Perfect for tucking into high-waisted jeans, layering under jackets, or simply lounging at home in style."
    ],
    Features: [
      "Relaxed, boxy fit with dropped shoulders",
      "Made from soft, premium mid-weight cotton",
      "Classic ribbed crew neckline",
      "Wide, comfortable half-sleeves",
      "Easy-care fabric that maintains its shape after washing"
    ],
  },
  {
    id: 5,
    name: "Burgundy scoop-neck ribbed tank",
    category: "Tops",
    price: "45.00",
    reviews: "156",
    rating: "4.5",
    image: "/img/ovh-product-05.png",
    images: ["/img/ovh-product-05.png"],
    size: ["XS", "S", "M", "L"],
    colors: ["Burgundy", "Black", "White"],
    material: "95% Cotton, 5% Elastane",
    description: [
      "A versatile foundation piece, this classic ribbed tank top is essential for seamless layering and warm-weather styling.",
      "The finely ribbed texture not only adds visual interest but also provides a naturally stretchy, form-hugging fit.",
      "Designed with a flattering scoop neckline and wide straps that offer excellent coverage and support.",
      "Made from a breathable cotton blend, it ensures all-day comfort and retains its shape wear after wear.",
      "Tuck it into tailored trousers for a sleek look, or wear it casually with your favorite denim shorts."
    ],
    Features: [
      "Finely ribbed texture for a snug, stretchy fit",
      "Flattering scoop neckline and wide shoulder straps",
      "Breathable cotton-elastane blend for comfort",
      "Form-fitting silhouette ideal for layering",
      "Available in a variety of rich, seasonal colors"
    ],
  },
  {
    id: 6,
    name: "Grey melange ribbed tank",
    category: "Tops",
    price: "45.00",
    reviews: "142",
    rating: "4.6",
    image: "/img/ovh-product-06.png",
    images: ["/img/ovh-product-06.png"],
    size: ["XS", "S", "M", "L"],
    colors: ["Grey Melange", "Olive"],
    material: "95% Cotton, 5% Elastane",
    description: [
      "Update your basics with this classic ribbed tank top, featuring a subtle melange texture for a relaxed, lived-in look.",
      "The ribbed knit construction offers a comfortable stretch that contours gently to the body without feeling restrictive.",
      "A timeless scoop neck design makes it an incredibly versatile piece that works well across different seasons.",
      "Crafted from a soft cotton blend, it provides excellent breathability, making it perfect for active days or lounging.",
      "An effortless match for wide-leg trousers, skirts, or layered under an open button-down shirt for a casual vibe."
    ],
    Features: [
      "Subtle melange finish for a relaxed aesthetic",
      "Stretchy ribbed knit for a contoured fit",
      "Classic scoop neckline design",
      "Soft and breathable fabric composition",
      "Perfect for wearing solo or as a base layer"
    ],
  },
  {
    id: 7,
    name: "Earth-tone scoop-neck ribbed tank",
    category: "Tops",
    price: "45.00",
    reviews: "178",
    rating: "4.7",
    image: "/img/ovh-product-07.png",
    images: ["/img/ovh-product-07.png"],
    size: ["XS", "S", "M", "L"],
    colors: ["Brown", "Beige", "Black"],
    material: "95% Cotton, 5% Elastane",
    description: [
      "Embrace earthy tones with this classic ribbed tank top, a must-have staple for creating effortless, neutral-toned outfits.",
      "Its ribbed texture provides a flattering, body-skimming fit that highlights the silhouette while remaining incredibly comfortable.",
      "Featuring a perfectly proportioned scoop neckline that is modest yet feminine, suitable for various occasions.",
      "The premium cotton blend fabric is soft to the touch and offers the perfect amount of stretch for daily wear.",
      "Style it monochromatically with matching brown trousers, or use it as a grounding piece with vibrant skirts."
    ],
    Features: [
      "Rich, earthy color palette",
      "Flattering ribbed texture with built-in stretch",
      "Comfortable wide straps and scoop neck",
      "Durable and soft cotton-blend fabric",
      "Highly versatile for mixing and matching"
    ],
  },
  {
    id: 8,
    name: "Waist-pleated poplin shirt",
    category: "Shirts",
    price: "55.00",
    reviews: "95",
    rating: "4.8",
    image: "/img/ovh-product-08.png",
    images: ["/img/ovh-product-08.png"],
    size: ["XS", "S", "M", "L"],
    colors: ["Light Blue", "White"],
    material: "100% Poplin Cotton",
    description: [
      "A masterclass in modern tailoring, this pleated shirt offers a structured yet feminine approach to the classic button-down.",
      "Intricate pleating details at the waist create a beautifully cinched silhouette that flatters the figure effortlessly.",
      "Crafted from crisp poplin cotton, it maintains a sharp, polished appearance throughout the day.",
      "Featuring a sleek V-neckline and long sleeves with buttoned cuffs, it exudes sophistication and confidence.",
      "An exceptional choice for professional settings, pairing flawlessly with tailored trousers or a sleek pencil skirt."
    ],
    Features: [
      "Sophisticated waist pleating for a tailored fit",
      "Crisp and breathable 100% poplin cotton",
      "Elegant V-neckline with front button closure",
      "Long sleeves with classic buttoned cuffs",
      "Structured silhouette that maintains its shape"
    ],
  },
  {
    id: 9,
    name: "Black fluid drawstring trousers",
    category: "Trousers",
    price: "45.00",
    reviews: "260",
    rating: "4.6",
    image: "/img/ovh-product-09.png",
    images: ["/img/ovh-product-09.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Black", "Navy"],
    material: "65% Polyester, 35% Viscose",
    description: [
      "Experience the perfect fusion of comfort and elegance with these drawstring wide-leg trousers, designed for effortless style.",
      "The sweeping wide-leg silhouette provides a relaxed, fluid movement that is both chic and incredibly comfortable.",
      "An elasticated waistband with an adjustable drawstring ensures a customized and secure fit for all-day wear.",
      "Crafted from a smooth, lightweight fabric blend that drapes beautifully and resists severe wrinkling.",
      "Versatile enough to be dressed up with a blouse and heels or kept casual with a simple t-shirt and sneakers."
    ],
    Features: [
      "Elegant, sweeping wide-leg cut",
      "Comfortable elasticated waist with adjustable drawstring",
      "Smooth, fluid fabric that drapes beautifully",
      "Functional side seam pockets",
      "Versatile design suitable for work or weekend wear"
    ],
  },
  {
    id: 10,
    name: "Brown stripe relaxed long-sleeve tee",
    category: "T-shirts",
    price: "48.00",
    reviews: "185",
    rating: "4.5",
    image: "/img/ovh-product-10.png",
    images: ["/img/ovh-product-10.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Brown Striped", "Black Striped"],
    material: "100% Cotton",
    description: [
      "Add a touch of classic pattern to your wardrobe with this striped long-sleeved t-shirt, a timeless piece for transitional weather.",
      "Featuring a relaxed fit that offers ample room for movement while maintaining a clean, casual aesthetic.",
      "Made from soft, breathable cotton that provides comfort and warmth without feeling overly heavy.",
      "The classic crew neckline and dropped shoulders enhance its laid-back appeal, making it a perfect everyday staple.",
      "Layer it under a denim jacket or wear it solo with wide-leg trousers for a chic, Parisian-inspired look."
    ],
    Features: [
      "Classic horizontal stripe pattern",
      "Comfortable, relaxed fit with dropped shoulders",
      "Made from 100% soft, breathable cotton",
      "Ribbed crew neckline for durability",
      "Ideal for layering during transitional seasons"
    ],
  },
  {
    id: 11,
    name: "Pastel stripe boxy long-sleeve tee",
    category: "T-shirts",
    price: "48.00",
    reviews: "192",
    rating: "4.7",
    image: "/img/ovh-product-11.png",
    images: ["/img/ovh-product-11.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Pink Striped", "Blue Striped"],
    material: "100% Cotton",
    description: [
      "Brighten up your casual wear with this pastel striped long-sleeved t-shirt, combining comfort with a playful pop of color.",
      "Designed with a loose, boxy silhouette that drapes effortlessly, providing a relaxed and contemporary vibe.",
      "Constructed from premium cotton jersey, it is exceptionally soft against the skin and built to last.",
      "The long sleeves and crew neckline make it a versatile piece that can be worn comfortably year-round.",
      "Pairs wonderfully with light-wash denim or tucked into a midi skirt for a fun, relaxed weekend outfit."
    ],
    Features: [
      "Playful pastel stripe design",
      "Loose, boxy silhouette for a contemporary look",
      "Premium soft cotton jersey fabric",
      "Classic crew neck and long sleeves",
      "Easy to style for casual, everyday wear"
    ],
  },
  {
    id: 12,
    name: "Green stripe oversized cotton tee",
    category: "T-shirts",
    price: "49.00",
    reviews: "210",
    rating: "4.6",
    image: "/img/ovh-product-12.png",
    images: ["/img/ovh-product-12.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Pink Striped", "Green Striped"],
    material: "100% Cotton",
    description: [
      "A fresh take on a classic, this loose fit striped t-shirt offers an effortless way to inject pattern into your daily rotation.",
      "The oversized fit and dropped shoulders create a supremely relaxed silhouette that is perfect for laid-back days.",
      "Crafted from lightweight, breathable cotton, it keeps you cool and comfortable even during warmer weather.",
      "Features wide half-sleeves and a simple crew neck, emphasizing its easy-going, comfortable design.",
      "Throw it on over shorts or pair it with relaxed trousers for an instantly stylish, low-effort ensemble."
    ],
    Features: [
      "Fresh, summery striped pattern",
      "Oversized fit with dropped shoulders",
      "Lightweight and breathable 100% cotton",
      "Wide half-sleeves for added comfort",
      "Perfect for warm weather casual styling"
    ],
  },
  {
    id: 13,
    name: "Cocoa drawstring wide-leg trousers",
    category: "Trousers",
    price: "45.00",
    reviews: "234",
    rating: "4.8",
    image: "/img/ovh-product-13.png",
    images: ["/img/ovh-product-13.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Brown", "Beige"],
    material: "65% Polyester, 35% Viscose",
    description: [
      "Embrace relaxed tailoring with these brown drawstring wide-leg trousers, offering a chic alternative to standard workwear.",
      "The generous wide-leg cut provides a beautiful, sweeping movement and an elongating effect on the silhouette.",
      "An elasticated waist with a tonal drawstring guarantees a comfortable, custom fit without sacrificing style.",
      "Made from a soft, fluid fabric that feels luxurious against the skin and drapes elegantly.",
      "A versatile earthy tone that pairs beautifully with cream knits, simple tees, or matching neutral blouses."
    ],
    Features: [
      "Generous, elongating wide-leg silhouette",
      "Adjustable drawstring waist for maximum comfort",
      "Soft, fluid fabric with an elegant drape",
      "Rich, earthy color palette",
      "Practical side pockets for convenience"
    ],
  },
  {
    id: 14,
    name: "Camel funnel-neck cropped jacket",
    category: "Jackets",
    price: "110.00",
    reviews: "145",
    rating: "4.7",
    image: "/img/ovh-product-14.png",
    images: ["/img/ovh-product-14.png"],
    size: ["XS", "S", "M", "L"],
    colors: ["Beige", "Camel"],
    material: "50% Wool, 50% Polyester",
    description: [
      "A masterpiece of modern outerwear, this short jacket combines architectural design with cozy warmth.",
      "Featuring a striking asymmetric button fastening and a high funnel neckline that provides extra protection against the cold.",
      "The cropped, boxy silhouette offers a contemporary edge, making it an excellent layering piece over dresses or high-waisted bottoms.",
      "Crafted from a premium wool blend, it offers substantial warmth while maintaining a refined, structured look.",
      "Complete with practical welt pockets and a fully lined interior for a smooth, comfortable fit over chunky knitwear."
    ],
    Features: [
      "Contemporary asymmetric button fastening",
      "High funnel neckline for added warmth and style",
      "Cropped, boxy silhouette",
      "Warm and structured wool-blend fabric",
      "Fully lined interior with practical front pockets"
    ],
  },
  {
    id: 15,
    name: "Charcoal crease-front drawstring trousers",
    category: "Trousers",
    price: "45.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/ovh-product-15.png",
    images: ["/img/ovh-product-15.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Grey", "Charcoal"],
    material: "65% Polyester, 35% Viscose",
    description: [
      "These grey drawstring wide-leg trousers perfectly bridge the gap between polished office wear and relaxed weekend comfort.",
      "The subtle front crease detailing adds a touch of sharp tailoring to the otherwise relaxed, flowing silhouette.",
      "Featuring a comfortable elasticated waistband with a discreet drawstring, allowing for a personalized fit.",
      "The mid-weight fabric offers excellent drape and resists creasing, keeping you looking sharp all day long.",
      "Style them with a crisp white shirt for a smart-casual office look, or with a chunky sweater for weekend brunches."
    ],
    Features: [
      "Flowing wide-leg cut with subtle front crease",
      "Comfortable elasticated waist with drawstring",
      "Mid-weight, crease-resistant fabric blend",
      "Versatile grey tone suitable for any occasion",
      "Combines tailored details with casual comfort"
    ],
  },
  {
    id: 16,
    name: "Brown stripe extended-sleeve cotton tee",
    category: "T-shirts",
    price: "49.00",
    reviews: "175",
    rating: "4.5",
    image: "/img/ovh-product-16.png",
    images: ["/img/ovh-product-16.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Brown Striped", "Black Striped"],
    material: "100% Cotton",
    description: [
      "Effortlessly cool, this brown striped loose fit t-shirt is a versatile staple that adds subtle pattern to your everyday looks.",
      "The relaxed, oversized fit ensures maximum comfort and a modern, draped silhouette.",
      "Made from pure, soft cotton that provides excellent breathability and feels great against the skin.",
      "Detailed with a classic crew neckline and slightly longer half-sleeves for a distinct, laid-back aesthetic.",
      "An easy piece to throw on with your favorite jeans, shorts, or wide-leg trousers for a casual, stylish outfit."
    ],
    Features: [
      "Classic brown and white stripe pattern",
      "Relaxed, oversized fit for effortless styling",
      "Breathable and soft 100% cotton construction",
      "Classic crew neck and extended half-sleeves",
      "Durable fabric that holds its shape"
    ],
  },
  {
    id: 17,
    name: "Grey asymmetric wool-blend jacket",
    category: "Jackets",
    price: "110.00",
    reviews: "132",
    rating: "4.8",
    image: "/img/ovh-product-17.png",
    images: ["/img/ovh-product-17.png"],
    size: ["XS", "S", "M", "L"],
    colors: ["Grey Melange", "Black"],
    material: "50% Wool, 50% Polyester",
    description: [
      "Sleek and sophisticated, this grey short jacket is a modern outerwear essential that elevates any ensemble.",
      "The distinct asymmetric front closure and stand collar create a sharp, architectural look that stands out.",
      "Cut in a cropped, structured silhouette that pairs perfectly with high-waisted trousers or skirts.",
      "The textured wool-blend fabric provides excellent insulation, making it ideal for chilly days.",
      "Finished with clean lines, hidden snap buttons, and subtle front pockets for a minimalist, refined aesthetic."
    ],
    Features: [
      "Sharp asymmetric front closure",
      "Structured, cropped silhouette",
      "Textured and warm wool-blend fabric",
      "Minimalist design with clean lines",
      "Stand collar for added style and wind protection"
    ],
  },
  {
    id: 18,
    name: "Patterned pleat-front wide-leg trousers",
    category: "Trousers",
    price: "45.00",
    reviews: "156",
    rating: "4.7",
    image: "/img/ovh-product-18.png",
    images: ["/img/ovh-product-18.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Grey Pattern", "Brown Pattern"],
    material: "63% Polyester, 33% Viscose, 4% Elastane",
    description: [
      "These textured wide-leg trousers bring a touch of classic tailoring to your wardrobe with a subtle, sophisticated pattern.",
      "Designed with a high, structured waistband and a zip fly fastening for a polished, tailored appearance.",
      "The wide-leg cut features crisp front pleats that elongate the legs and add volume and movement.",
      "Crafted from a slightly stretchy fabric blend, they offer comfort and flexibility while maintaining their sharp shape.",
      "Perfect for the office when paired with a blazer, or dressed down with a simple fitted knit for the evening."
    ],
    Features: [
      "Sophisticated subtle pattern design",
      "High structured waistband with zip fly",
      "Crisp front pleats for a tailored look",
      "Slightly stretchy fabric for added comfort",
      "Elegant wide-leg silhouette"
    ],
  },
  {
    id: 19,
    name: "Navy drape drawstring trousers",
    category: "Trousers",
    price: "45.00",
    reviews: "289",
    rating: "4.9",
    image: "/img/ovh-product-19.png",
    images: ["/img/ovh-product-19.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Navy", "Black"],
    material: "65% Polyester, 35% Viscose",
    description: [
      "A versatile essential, these navy drawstring wide-leg trousers combine the ease of loungewear with the look of tailored pants.",
      "The deep navy hue offers a chic alternative to black, pairing beautifully with crisp whites and soft pastels.",
      "Featuring a relaxed, flowing wide leg that provides exceptional comfort and a graceful silhouette.",
      "The elasticated waistband with an adjustable tie ensures a perfect fit, accommodating movement throughout the day.",
      "An incredibly adaptable piece that transitions seamlessly from a relaxed work environment to casual weekend outings."
    ],
    Features: [
      "Deep, versatile navy color",
      "Flowing wide-leg silhouette for graceful movement",
      "Comfortable elasticated waist with tie detail",
      "Smooth, drape-heavy fabric",
      "Easy to dress up or down"
    ],
  },
  {
    id: 20,
    name: "Quilted jacket",
    category: "Jackets",
    price: "60.00",
    reviews: "315",
    rating: "4.8",
    image: "/img/ovh-product-20.png",
    images: ["/img/ovh-product-20.png"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Black", "Olive"],
    material: "100% Recycled Polyester",
    description: [
      "Stay warm and stylish with this lightweight quilted jacket, a perfect transitional layer for unpredictable weather.",
      "The classic diamond quilting pattern not only provides even insulation but also adds a timeless textural element.",
      "Designed with a collarless neckline and button-through front, making it incredibly easy to layer over hoodies or under heavier coats.",
      "Features large, practical patch pockets at the front for storing essentials or warming hands.",
      "Crafted from recycled materials, it offers an eco-friendly approach to functional, everyday outerwear."
    ],
    Features: [
      "Classic diamond quilting for even warmth",
      "Lightweight yet insulating construction",
      "Collarless design ideal for layering",
      "Large, functional front patch pockets",
      "Made from eco-friendly recycled polyester"
    ],
  },
  {
    id: 21, name: "Belted linen-blend midi dress", category: "Dresses", price: "95.00", reviews: "86", rating: "4.7",
    image: "/img/ovh-product-21.png", images: ["/img/ovh-product-21.png"], size: ["XS", "S", "M", "L", "XL"], colors: ["Sand Beige", "Black"],
    material: "55% Linen, 45% Viscose",
    description: ["A breathable shirt dress with a removable self-tie belt and softly structured midi-length skirt.", "The linen-blend weave has a natural texture and comfortable drape suited to warm days.", "A concealed button front, side pockets and curved hem make it practical for everyday wear."],
    Features: ["Removable self-tie belt", "Functional side pockets", "Midi length", "Lightweight linen-blend weave"],
  },
  {
    id: 22, name: "Cropped knit cardigan", category: "Knitwear", price: "68.00", reviews: "73", rating: "4.6",
    image: "/img/ovh-product-22.png", images: ["/img/ovh-product-22.png"], size: ["XS", "S", "M", "L"], colors: ["Sage Green", "Cream"],
    material: "70% Cotton, 30% Nylon",
    description: ["A soft cropped cardigan in a fine knit that layers comfortably over dresses, tanks and tees.", "The neat crew neck, tonal buttons and ribbed edges create a clean everyday finish.", "Its mid-weight cotton blend offers warmth without feeling bulky."],
    Features: ["Fine-gauge knit", "Button front", "Ribbed cuffs and hem", "Cropped regular fit"],
  },
  {
    id: 23, name: "Tailored wrap midi skirt", category: "Skirts", price: "79.00", reviews: "64", rating: "4.8",
    image: "/img/ovh-product-23.png", images: ["/img/ovh-product-23.png"], size: ["XS", "S", "M", "L", "XL"], colors: ["Charcoal", "Stone"],
    material: "68% Polyester, 28% Viscose, 4% Elastane",
    description: ["This tailored midi skirt features an asymmetric wrap front and a clean high-rise waistband.", "The woven fabric keeps its shape while a touch of stretch supports comfortable movement.", "A discreet side fastening and back vent maintain a smooth, versatile silhouette."],
    Features: ["Asymmetric wrap front", "High-rise waist", "Back walking vent", "Light stretch"],
  },
  {
    id: 24, name: "Relaxed cotton overshirt", category: "Shirts", price: "72.00", reviews: "91", rating: "4.7",
    image: "/img/ovh-product-24.png", images: ["/img/ovh-product-24.png"], size: ["XS", "S", "M", "L", "XL"], colors: ["Cream", "Dusty Blue"],
    material: "100% Cotton",
    description: ["A relaxed overshirt cut from soft cotton twill with a naturally washed surface.", "Two chest pockets, buttoned cuffs and a curved hem give this layer a practical, familiar feel.", "Wear it open over a tank or buttoned as a lightweight shirt."],
    Features: ["Soft cotton twill", "Two chest pockets", "Buttoned cuffs", "Relaxed fit"],
  },
  {
    id: 25, name: "Pleated wide-leg trousers", category: "Trousers", price: "85.00", reviews: "108", rating: "4.9",
    image: "/img/ovh-product-25.png", images: ["/img/ovh-product-25.png"], size: ["XS", "S", "M", "L", "XL"], colors: ["Navy", "Taupe"],
    material: "64% Polyester, 32% Viscose, 4% Elastane",
    description: ["High-waisted trousers shaped with front pleats and a fluid wide leg for an easy tailored look.", "The smooth woven fabric drapes cleanly and includes gentle stretch for day-long comfort.", "Belt loops, side pockets and a concealed front fastening complete the design."],
    Features: ["Front pleat detail", "Wide-leg cut", "Functional side pockets", "Concealed fastening"],
  },
];

export default productData;
